"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./ComponentRowSingle.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ComponentRowSingle = function ComponentRowSingle(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)('component-row-single', props.customClass);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.header && /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('header')
  }, t(props.header)), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('component-container-100')
  }, props.component)));
};
ComponentRowSingle.propTypes = {
  component: _propTypes["default"].object,
  customClass: _propTypes["default"].string,
  header: _propTypes["default"].string
};
var _default = exports["default"] = ComponentRowSingle;